/** Find related content to the specified entity */

import type { Entity, Persisted, SearchFilter } from '@tunasong/schemas'
import { useMemo } from 'react'
import { allQueries } from './queries/index.js'
import { useAdvancedSearch } from './search.hook.js'

export const useRelatedContent = ({ entity, filter }: { entity?: Persisted<Entity>; filter?: SearchFilter }) => {
  /** This must be stable */
  const query = useMemo(
    () =>
      entity?.name
        ? allQueries.relatedContent({
            query: entity.name,
            filter,
          })
        : undefined,
    [entity, filter]
  )
  /** Spec §7.1 promises this surface a local answer; it gets one only if it says what it meant */
  return useAdvancedSearch(query, {
    queryType: 'relatedContent',
    intent: { query: entity?.name, types: filter?.types, tags: filter?.tags },
  })
}
